import { useOcDarklyBoolean, OcDarklyFlags } from '@oc/darkly/oc';
import { withTrackUnusedFields } from 'utils/gql/trackUnusedFields/withTrackUnusedFields';
import { DocumentNode } from 'graphql';
import { useCallback } from 'react';
import { captureGqlUnusedFieldsMetric } from 'integrations/sentry/sentry';

export function useTrackUnusedFields(documentNode: DocumentNode) {
  const { trackUnusedGqlFields } = useOcDarklyBoolean(OcDarklyFlags.BooleanFlag.trackUnusedGqlFields);

  return useCallback(
    <T extends object>(data: T | undefined | null): T | undefined | null =>
      trackUnusedGqlFields
        ? withTrackUnusedFields(data, documentNode, (operationName: string, unusedKeys: string[]) => {
            captureGqlUnusedFieldsMetric(operationName, unusedKeys.slice().sort());
          })
        : data,
    [documentNode, trackUnusedGqlFields]
  );
}
